export const formatAddress = (address: {
  street?: string;
  postalCode?: string;
  city?: string;
}): string => {
  return `${address.street ? `${address.street},` : ''}  ${
    address.postalCode ?? ''
  } ${address.city ?? ''}`.trim();
};
